<template>
  <modal>
    <div>
      <div class="modal-content">
        <div class="message text-center">{{ $t('tour_title_label') }}</div>
        <input :value="defaultTitle" @input="updateTitle($event.target.value)" class="input-station" />
      </div>
      <div class="modal-button flex justify-between">
        <a class="button-secondary block w-half" @click="closeModal">{{ $t('tour_cancel') }}</a>
        <a class="button-primary block w-half" @click="callback" :class="{disabled: isDisabled}">{{ $t('tour_save') }}</a>
      </div>
    </div>
  </modal>
</template>

<script>
import Modal from "../atoms/Modal"

export default {
  components: {
    Modal
  },
  props: {
    defaultTitle: {
      type: String
    },
    closeModal: {
      type: Function,
      default: function () {
        return {}
      }
    },
    callback: {
      type: Function,
      default: function () {
        return {}
      }
    },
  },
  data () {
    return {
      isDisabled: false
    }
  },
  methods: {
    updateTitle:  function (title) {
      this.isDisabled = title.length == 0 ? true : false
      this.$emit('updateTitle', title)
    }
  }
}
</script>
